// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1umXy","itemTitle":"ClientEmergencyInfo_itemTitle__3QLJm","itemText":"ClientEmergencyInfo_itemText__2gBSi"};